/**
 * 全局常量、方法封装模块
 * 通过原型挂载到Vue属性
 * 通过 this.Global 调用
 */

// 后台管理系统服务器地址
export const baseUrl = 'https://xkbd.net/api'
// 系统数据备份还原服务器地址
export const backupBaseUrl = 'https://xkbd.net/api'

export default {
    baseUrl,
    backupBaseUrl
}


// WEBPACK FOOTER //
// ./src/utils/global.js